export const defaultSpecialCard = '/assets/default-special-card.png';
